<template>
  <v-dialog
    data-testid="people_addUser_dialog"
    scrollable
    :persistent="currentStep !== STEPS.SELECTION"
    :max-width="modalWidth"
    :value="show"
    @click:outside="currentStep === STEPS.SELECTION ? handleClose() : false"
    @keydown.esc="handleEsc"
  >
    <SelectAddUserMethod
      v-if="currentStep === STEPS.SELECTION"
      data-testid="people_addUser_selection"
      :canInviteExternalUsers="canInviteExternalUsers"
      @selected="handleTypeSelection"
    />
    <AddUserForm
      v-if="currentStep === STEPS.FORM"
      :canAssignRole="canAssignRole"
      :rolesEnabled="rolesEnabled"
      :remainingUsersToAdd="remainingUsersToAdd"
      :organizationId="organizationId"
      @closeModal="handleClose"
      @clickBack="handleBack"
      @onUsersAdded="$emit('onUsersAdded', $event)"
    />
    <InviteExternalUserForm
      v-if="currentStep === STEPS.INVITE"
      data-testid="addUserModal-externalInvitationForm"
      :canAssignRole="canAssignRole"
      :organizationId="organizationId"
      :rolesEnabled="rolesEnabled"
      @clickBack="handleBack"
      @closeModal="handleClose"
      @onUsersAdded="$emit('onUsersAdded', $event)"
    />
  </v-dialog>
</template>

<script>
import mixin from '@/mixins/mixin'
import trackerMixin from '@/mixins/tracking/trackerMixin.vue'

import SelectAddUserMethod from './SelectAddUserMethod.vue'
import AddUserForm from './AddUserForm.vue'
import InviteExternalUserForm from './InviteExternalUserForm.vue'

import { ADD_USER_TYPES } from './constants.js'

const STEPS = Object.freeze({
  SELECTION: 'selection',
  FORM: 'form',
  INVITE: 'invite',
})

export default {
  name: 'AddUserModalBulkFeature',

  mixins: [mixin, trackerMixin],

  data() {
    return {
      STEPS,
      currentStep: STEPS.SELECTION,
      showTemplateDrawer: false,
      selectedTemplate: '',
    }
  },

  components: {
    SelectAddUserMethod,
    AddUserForm,
    InviteExternalUserForm,
  },

  props: {
    show: {
      type: Boolean,
      default() {
        return false
      },
    },

    size: {
      type: String,
      required: false,
      default: 'sm',
      enum: ['lg', 'sm'],
    },

    remainingUsersToAdd: {
      type: Number,
      required: true,
    },

    organizationId: {
      type: String,
      required: true,
    },

    rolesEnabled: {
      type: Array,
      required: false,
      default() {
        return ['isCoach']
      },
    },
    canAssignRole: {
      type: Boolean,
      required: true,
    },

    canInviteExternalUsers: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    modalWidth() {
      if (this.currentStep === STEPS.SELECTION)
        return this.canInviteExternalUsers ? '700' : '462'
      if (this.currentStep === STEPS.INVITE) return '560'
      return '700'
    },
  },

  methods: {
    handleTypeSelection(type) {
      this.trackAddPeopleNavigate({ element: type, section: 'addPeopleModal' })

      if (type === ADD_USER_TYPES.BULK) {
        return this.navigateTo({
          name: 'addUsersBulk',
          params: {
            organizationId: this.organizationId,
          },
        })
      }

      if (type === ADD_USER_TYPES.INVITE) {
        this.currentStep = STEPS.INVITE
        return
      }

      this.currentStep = STEPS.FORM
    },

    handleClose() {
      this.$emit('closeModal')
      this.currentStep = STEPS.SELECTION
    },
    handleEsc() {
      if (this.currentStep === STEPS.INVITE) return
      this.handleClose()
    },
    handleBack() {
      this.currentStep = STEPS.SELECTION
    },
  },
}
</script>
